import { createSelector } from "reselect";

import { userEntityAdapter, userSlice } from "./slice";

const selectUserState = (state) => state[userSlice.name];

export const selectUserEntities = createSelector(selectUserState, (userState) => userState.entities);

export const selectSelectedUserId = createSelector(selectUserState, (userState) => userState.selectedUserId);

export const selectSelectedUserDetails = createSelector(
  selectUserState,
  selectSelectedUserId,
  (userState, userId) => userEntityAdapter.getSelectors().selectById(userState, userId) || null,
);

export const selectSelectedUserName = createSelector(
  selectSelectedUserDetails,
  (userDetails) => userDetails?.name || "",
);

export const selectSelectedUserEmail = createSelector(
  selectSelectedUserDetails,
  (userDetails) => userDetails?.email || "",
);

export const selectSelectedUserSocialProfileKey = createSelector(
  selectSelectedUserDetails,
  (userDetails) => userDetails?.socialProfileKey || [],
);

export const selectUsers = createSelector(selectUserEntities, (userEntities) => Object.values(userEntities));

export const selectBrightCoveFolders = createSelector(selectUserState, (userState) => userState.brightCoveFolders);

export const selectBrightCoveFoldersList = createSelector(selectBrightCoveFolders, (brightCoveFolders) =>
  brightCoveFolders.map((folder) => ({
    value: folder.folderId,
    label: folder.name,
  })),
);
